module.exports = __webpack_public_path__ + "fonts/HelveticaNeue-Bold.cf39be6b.eot";